import { __awaiter, __generator } from "tslib";
import { container } from 'tsyringe';
import { Basket } from '../basket';
import { BasketTranslationService } from '../services';
/**
 * Sets necessary prerequisites and bootstraps SFCC basket.
 * @param currency currency to bootstrap SFCC basket with
 */
export var bootstrapSFCCBasket = function (settings) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, _b, _c;
    var _d;
    return __generator(this, function (_e) {
        switch (_e.label) {
            case 0:
                // Register constants
                container.register("basketSettings" /* DiToken.Settings */, { useValue: settings });
                container.register("basketStorage" /* DiToken.Storage */, { useValue: localStorage });
                _b = (_a = container).register;
                _c = ["basketTranslations" /* DiToken.Translations */];
                _d = {};
                return [4 /*yield*/, getTranslations()];
            case 1:
                _b.apply(_a, _c.concat([(_d.useValue = _e.sent(), _d)]));
                // Bootstrap basket
                return [4 /*yield*/, container.resolve(Basket)
                        .bootstrap()];
            case 2:
                // Bootstrap basket
                _e.sent();
                return [2 /*return*/];
        }
    });
}); };
/**
 * Gets translations for basket and put into `container`.
 */
var getTranslations = function () { return __awaiter(void 0, void 0, void 0, function () {
    var service;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                service = new BasketTranslationService();
                return [4 /*yield*/, service.translations];
            case 1: return [2 /*return*/, _a.sent()];
        }
    });
}); };
